import React, { useCallback, type ReactNode } from 'react';
import Button from '@atlaskit/button';
import EditorInfoIcon from '@atlaskit/icon/glyph/editor/info';
import { Flex, Text, xcss } from '@atlaskit/primitives';
import { token } from '@atlaskit/tokens';
import { FormattedMessage } from '@atlassian/jira-intl';
import {
	useAdvancedOptions,
	useMappingState,
	useProjectData,
} from '../../../controllers/import-state';
import messages from './messages';
import { getConfiguration, getFileName } from './utils';

export const DownloadConfiguration = () => {
	const [projectData] = useProjectData();
	const [mappingState] = useMappingState();
	const [advancedOptions] = useAdvancedOptions();

	const onDownload = useCallback(() => {
		const jsonConfig = JSON.stringify(
			getConfiguration(mappingState, advancedOptions, projectData),
			null,
			2,
		);
		const blob = new Blob([jsonConfig], { type: 'text/plain' });
		const href = URL.createObjectURL(blob);
		const link = document.createElement('a');
		link.href = href;
		link.download = getFileName(projectData.name);
		link.click();
		URL.revokeObjectURL(href);
	}, [advancedOptions, mappingState, projectData]);

	return (
		<Flex alignItems="center" gap="space.050" xcss={downloadTextStyles}>
			<EditorInfoIcon size="medium" label="" primaryColor={token('color.icon.discovery')} />
			<Text>
				<FormattedMessage
					{...messages.downloadConfiguration}
					values={{
						link: (content: ReactNode) => (
							<Button appearance="link" onClick={onDownload} spacing="none">
								{content}
							</Button>
						),
					}}
				/>
			</Text>
		</Flex>
	);
};

const downloadTextStyles = xcss({
	paddingBlock: 'space.200',
});
